import { Component, ViewEncapsulation, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MCButtonComponent } from '@maslul/common-components';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'mi-app-menu',
    imports: [
        CommonModule,
        RouterModule,
        MCButtonComponent
    ],
    templateUrl: './menu.component.html',
    styleUrl: './menu.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class MenuComponent implements OnInit, OnDestroy {
  sidebarVisible: boolean = false;
  subscribtion: Subscription = new Subscription();
  menuText: any;
  isCloseLanguage: boolean = true;
  isCloseHelpInformation: boolean = true;

  constructor(private translateService: TranslateService) { }


  ngOnInit(): void {
    this.initText();


  }

  initText() {

    this.subscribtion.add(this.translateService.stream('menu').subscribe(translation => {
      this.menuText = translation;
    }));

  }

  toggleMenu(): void {
    this.sidebarVisible = !this.sidebarVisible;
  }

  closeMenu(): void {
    this.sidebarVisible = false;
  }

  ngOnDestroy(): void {
    this.subscribtion.unsubscribe();
  }

  toggleLanguage() {
    this.isCloseLanguage = !this.isCloseLanguage
  }
  toggleHelpInformation() {
    this.isCloseHelpInformation = !this.isCloseHelpInformation;
  }
}
